import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 7.5V21m0 0a9 9 0 0 1-9-9m9 9a9 9 0 0 0 9-9M3 12h2.5M21 12h-2.5M9 11h6m-.5-6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    }, null, -1)
  ])))
}
export default { render: render }